import { useData } from './data';
import { isAdmin, selectedMembership } from './membership';

/* INTERFACES */
export interface RestPermissable {
  $permissions: string[];
}

export interface GqlPermissable {
  permissions: Record<string, boolean> | { __typename?: string };
}

export type Permissable = RestPermissable | GqlPermissable;

export type Permission<T extends Partial<Permissable>> =
  | (T extends RestPermissable ? T['$permissions'][0] : T extends GqlPermissable ? keyof T['permissions'] : never)
  | SpecialPermission;

export type BasePermissions = 'create' | 'update' | 'show' | 'destroy';

export type SpecialPermission = 'isAdmin';

/* HOOKS */
export function usePermission<Record extends Permissable>(
  subject: Record | undefined,
  permission: Permission<Record>
): boolean {
  const membership = useData(selectedMembership);
  if (!membership) {
    return false;
  }
  if (permission === 'isAdmin') {
    return isAdmin(membership);
  }
  if (!subject) {
    return false;
  }
  if ('$permissions' in subject) {
    return !!subject.$permissions?.includes(permission);
  } else {
    return !!subject.permissions?.[permission.toString()];
  }
}
